<template>
  <news-form
    action="create"
    :data="data"
    :loading="loading"
    :updating="creating"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
    @generate:slug="val => data.slug = val"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { computed, ref, getCurrentInstance } from '@vue/composition-api'

import NewsForm from './news-form/NewsForm.vue'

export default {
  components: {
    NewsForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy

    const data = ref({})
    const errorMessages = ref([])

    const loading = ref(false)
    const creating = computed(() => vm.$store.getters['news/creating'])

    const handleFormSubmit = formData => {
      vm.$store
        .dispatch('news/create', formData)
        .then(res => {
          if (res?.status === 200 && res?.data?.data?.article) {
            const newsId = res.data.data.article.id

            vm.$router.replace({
              name: 'news-view',
              params: {
                id: newsId,
              },
            })
          }
        })
        .catch(err => {
          if (err?.data?.errors) {
            errorMessages.value = err.data.errors
          }
        })
    }

    const handleDiscard = () => vm.$router.replace({ name: 'news-list' })

    return {
      loading,
      creating,

      errorMessages,

      handleFormSubmit,
      handleDiscard,

      data,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
